import '../styles/css/BurgerNav.css';

import React from 'react'

function BurgerNav() {
    return (
        <div className="burger-nav">
            
        </div>
    )
}

export default BurgerNav
